const getters = {
  token: state => state.user.token,
  isUser: state => state.user.entry === 'user',
  userInfo: state => state.user.userInfo || {},
  permissionRoutes: state => state.user.routes || [],
  btnPermission: state => state.user.btnPermission || [],
  wordbooks: state => state.base.wordbooks || [],
  instList: state => state.list.instList || [],
  productList: state => state.list.productList || [],
  creditorList: state => state.list.creditorList || [],
  creditorProductList: state => state.list.creditorProductList || [],
  platformNo:state => state.list.platformNo || null,
}
export default getters
